import axios from 'axios'
import {CyLoading, CyMsgBox} from './tiptool'
import {UserUtils} from './user'

axios.defaults.withCredentials = true

// 访问微信后台
const axiosInstance = axios.create({
  baseURL: process.env.WX_API_URL
})

/* Axios拦截器 */
axiosInstance.interceptors.request.use(function (config) {
  config.headers.ssoToken = UserUtils.getToken()
  // console.log(config.url)
  if (config.params == null || config.params.loading == null || config.params.loading !== false) {
    CyLoading.startLoading()
  }
  return config
}, function (error) {
  CyLoading.endLoading()
  CyMsgBox.alert('请求失败！')
  return Promise.reject(error)
})

axiosInstance.interceptors.response.use(function (response) {
  CyLoading.endLoading()
  return response.data
}, function (error) {
  CyLoading.endLoading()
  CyMsgBox.alert('请求失败！')
  return Promise.reject(error)
})

// 后台登录SSO
const axiosSSO = axios.create({
  baseURL: process.env.SSO_API_URL // api的base_url
})

/* Axios拦截器 */
axiosSSO.interceptors.request.use(function (config) {
  console.log(config)
  config.headers.ssoToken = UserUtils.getToken()
  if (config.params == null || config.params.loading == null || config.params.loading !== false) {
    CyLoading.startLoading()
  }
  return config
}, function (error) {
  CyLoading.endLoading()
  CyMsgBox.alert('请求失败！')
  return Promise.reject(error)
})

axiosSSO.interceptors.response.use(function (response) {
  CyLoading.endLoading()
  let data = response.data
  return data
}, function (error) {
  CyLoading.endLoading()
  CyMsgBox.alert('响应异常！')
  return Promise.reject(error)
})

// Web服务接口访问
const axiosWeb = axios.create({
  baseURL: process.env.WEB_API_URL // api的base_url
})

/* Axios拦截器 */
axiosWeb.interceptors.request.use(function (config) {
  config.headers.ssoToken = UserUtils.getToken()
  if (config.params == null || config.params.loading == null || config.params.loading !== false) {
    CyLoading.startLoading()
  }
  return config
}, function (error) {
  CyLoading.endLoading()
  CyMsgBox.alert('请求失败！')
  return Promise.reject(error)
})

axiosWeb.interceptors.response.use(function (response) {
  CyLoading.endLoading()
  let data = response.data
  return data
}, function (error) {
  CyLoading.endLoading()
  CyMsgBox.alert('响应异常！')
  return Promise.reject(error)
})

// 第三方平台接口调用
const axiosOpenApi = axios.create()

/* Axios拦截器 */
axiosOpenApi.interceptors.request.use(function (config) {
  if (config.params == null || config.params.loading == null || config.params.loading !== false) {
    CyLoading.startLoading()
  }
  return config
}, function (error) {
  CyLoading.endLoading()
  CyMsgBox.alert('请求失败！')
  return Promise.reject(error)
})

axiosOpenApi.interceptors.response.use(function (response) {
  CyLoading.endLoading()
  return response
}, function (error) {
  CyLoading.endLoading()
  CyMsgBox.alert('请求失败！')
  return Promise.reject(error)
})

export {
  axiosInstance,
  axiosSSO,
  axiosWeb,
  axiosOpenApi
}



// WEBPACK FOOTER //
// ./src/assets/js/axios.js